import { NetworkStatus } from '@cbridge-utils/network';
import { IPriceFilteringStore } from './priceFiltering.interface';

export const priceFilteringInitialState: IPriceFilteringStore = {
  data: {},
  defaultData: {
    priceFilteringDefaultId: undefined,
    maxClientMarketDepth: undefined,
    maxBookbMarketDepth: undefined,
  },
  networkStatus: NetworkStatus.None,
};
